<scitis-menu-search #search
                    [isSuperAdmin]="isSuperAdminRole"
                    [userGroupId]="userGroupId"
                    [firebaseUserId]="firebaseUserId"
                    [userRole]="userRole"
                    [whiteListedMachineryGroups]="whiteListedMachineryGroups"
                    (menuItemSelected)="onMenuItemSelected($event, overview, favorites)">
</scitis-menu-search>

<div class="sidebar-scroll-container">
  <div class="sidebar-item-wrapper">
    <scitis-favorites #favorites (menuItemSelected)="onMenuItemSelected($event, overview, favorites)"
                      (expand)="onExpandFavorites(overview)"></scitis-favorites>
    <scitis-menu-overview #overview
                          [isAdminOrHigher]="isAdminOrHigher"
                          [isHigherThanAdmin]="isHigherThanAdmin"
                          [userRole]="userRole"
                          [firebaseUserId]="firebaseUserId"
                          [whiteListedMachineryGroups]="whiteListedMachineryGroups"
                          [whiteListedMachineryGroupsMap]="whiteListedMachineryGroupsMap"
                          (expand)="onExpandOverview(favorites)"></scitis-menu-overview>
  </div>
</div>
